module.exports = __webpack_public_path__ + "img/building-05.848a770b.svg";